import React, { memo } from 'react';
import Icon from 'components/Icon';
import {
  ICommonQuestionView,
  IQuestionTags,
  ISurveyItem,
  ISurveyView,
  QuestionState,
  QuestionTypes,
} from 'store/survey/surveyTypes';
import i18n from '../../../../../../i18n';

interface IComponentProps {
  hint: string;
  type: QuestionTypes;
  distinctive: boolean;
  answerRequired: boolean;
  survey?: ISurveyView;
}

export interface IQuestionViewerProp {
  tags: IQuestionTags;
  index: number;
  surveyId: number;
  providerSurvey: { data: ISurveyItem };
  question: { data: ICommonQuestionView; state: QuestionState };
  displayDeleted: boolean;
  readOnly: boolean;
  isOwnerOrSupport?: boolean;
  questionState?: {
    editing: boolean;
    loading: boolean;
  };
}

const GeneralQuestionViewer: React.FC<IComponentProps> = ({
  // hint,
  type,
  distinctive,
  answerRequired,
  survey,
}) => {
  return (
    <div style={{ marginTop: '10px' }}>
      {survey?.surveyType !== 'Exam' && survey?.surveyType !== 'Bank' && (
        <div className="col s12">
          <p>
            <Icon
              type={answerRequired ? 'check-square' : 'square'}
              className="right"
            />
            {i18n.t('answerRequiredLabel', { ns: 'survey' }) as string}
          </p>
          {type === 'multipleChoice' && (
            <p>
              <Icon
                type={distinctive ? 'check-square' : 'square'}
                className="right"
              />
              {i18n.t('distinctiveLabel', { ns: 'survey' }) as string}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default memo(GeneralQuestionViewer);
